import { createSearchParams, useSearchParams } from 'react-router-dom';

export const useUrlSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const removeSearchParam = (key: string) => {
    searchParams.delete(key);
    setSearchParams(searchParams);
  };

  const updateSearchParam = ({
    key,
    value,
  }: {
    key: string;
    value: string;
  }) => {
    searchParams.set(key, value);
    searchParams.sort();
    setSearchParams(searchParams);
  };

  const stringifySearchParams = (params?: URLSearchParams) => {
    return `?${createSearchParams(params || searchParams)}`;
  };

  return {
    stringifySearchParams,
    updateSearchParam,
    removeSearchParam,
    searchParams,
  };
};
